'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsChecklistLayout', ['$scope', 'IPTemplates', '$state', '$rootScope', function ($scope, IPTemplates, $state, $rootScope) {
        $scope.resetChecklist();
        $scope.saving = false;
        $scope.resetting = false;
        $scope.typeOptions = [
            { name: $rootScope.enterprise.serviceLabels['SERVICE'], id: 'service' },
            { name: $rootScope.enterprise.vehicleLabels['VEHICLE'], id: 'vehicle' }
        ];
        $scope.resultOptionsWithoutFail = [
            { id: 0, name: "Pass" },
            { id: 2, name: "N/A" }
        ];
        $scope.resultOptionsWithFail = [
            { id: 0, name: "Pass" },
            { id: 1, name: "Fail" },
            { id: 2, name: "N/A" }
        ];
        $scope.isDetailsOpen = true;
        $scope.isSettingsOpen = true;
        $scope.isResultsOpen = true;

        $scope.addLicenseLevel = function (checklist) {
            if (checklist.license_level != null) {
                checklist.license_levels.push(angular.copy(checklist.license_level));
                checklist.license_level = null;
                checklist.new_license_level = false;
            }
        }

        $scope.removeLicenseLevel = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        if ($scope.checklist.passing_score_type === null || $scope.checklist.passing_score_type === undefined) {
            $scope.checklist.passing_score_type = false;
        }

        $scope.save = function () {
            $scope.saving = true;
            IPTemplates.save($scope.checklist).then(function (checklist) {
                $scope.saving = false;
                $scope.setMasterChecklist(checklist);
                if (checklist != null && $scope.checklistID == null) {
                    $state.go('internal.inspecting.resource.checklist.layout', { id: checklist.id, checklist: checklist });
                }

                filterOptions($scope.checklist.inspection_type); // checklist reset so re-add checklist.options
            })
        }

        $scope.reset = function () {
            $scope.resetting = true;
            $scope.resetChecklist();
            $scope.resetting = false;
        }

        $scope.initChange = function (results, result) {
            results.forEach(function (r) {
                r.initval = false;
            })
            result.initval = true;
        }

        $scope.clearDefault = function (resultSet) {
            resultSet.forEach(function (result) {
                result.initval = false;
            })
        }

        $scope.removeResult = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.addResult = function (array) {
            array.push({ id: guid(), initval: false, show_comments: false, template_id: $scope.checklistID });
        }

        $scope.getOptions = function (resultSet, result) {
            var hasFail = false;
            var isFail = false;

            resultSet.forEach(function (r) {
                if (r.fail == 1) {
                    hasFail = true;
                    if (r.id == result.id) {
                        isFail = true;
                    }
                }
            })

            if (!hasFail) {
                return $scope.resultOptionsWithFail;
            }
            else {
                if (isFail) {
                    return $scope.resultOptionsWithFail;
                }
                else {
                    return $scope.resultOptionsWithoutFail;
                }
            }
        }

        function filterOptions(entity) {
            if(entity === 'service') entity = 'Services'
            if (entity === 'vehicle') entity = 'Vehicles'
            $scope.checklist.options = $scope.options.filter(function (option) {
                return option.entity_name === entity;
            });
        }
        IPTemplates.getInspectionLicenseLevelOptions($scope.checklistID).then(function (levelOptions) {
            $scope.options = levelOptions;

            filterOptions($scope.checklist.inspection_type);
        });

        $scope.clearLevels = function () {
            $scope.checklist.license_levels = [];
            if ($scope.checklist.inspection_type === 'service') {
                $scope.parameters = 'Services';
            } else if ($scope.checklist.inspection_type === 'vehicle') {
                $scope.parameters = 'Vehicles';
            }
            filterOptions($scope.checklist.inspection_type);
        }

        $scope.$watch('checklist.id', function (newId) {
            if (newId) {
                if ($scope.checklist.license_levels === null || $scope.checklist.license_levels === undefined) $scope.checklist.license_levels = [];

                if ($scope.checklist.inspection_type === 'service') {
                    $scope.parameters = 'Services';
                } else if ($scope.checklist.inspection_type === 'vehicle') {
                    $scope.parameters = 'Vehicles';
                }
                IPTemplates.getInspectionLicenseLevels($scope.checklist.id).then(function (license_levels) {
                    $scope.checklist.license_levels = license_levels;
                });

                filterOptions($scope.checklist.inspection_type);
            }
        }, true);

        $scope.cke_skin = 'bootstrapck';
    }])
    ;